import GImage from "../../g-image/Gimage";
import { palette } from "@interia/common/styles/global"
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react"
import { Media, Timeline } from "types"
import { Row, ImageColumn, BorderColumn, DescriptionColumn, Description, Image, MiddleLine, BlueCircle, Arrow } from './timelineRow.style'
const HtmlToReactParser = require('html-to-react').Parser;


type Props = {
  image: Media,
  description: string,
  lastElement?: boolean
}

const TimelineRow = ({ image, description, lastElement }: Props) => {

  const htmlToReactParser = new HtmlToReactParser();
  const parsedDescription = htmlToReactParser.parse(description);
  const gatsbyImage = getImage(image?.gatsbyImage)


  return (
    <Row >
      <ImageColumn>
        <GImage image={image} />
      </ImageColumn>
      <BorderColumn>
        <MiddleLine />
        <BlueCircle />
        {lastElement && <Arrow />}
      </BorderColumn>
      <DescriptionColumn>
        <Description>
          {parsedDescription}
        </Description>
      </DescriptionColumn>
    </Row>
  )
}

export default TimelineRow
